module.exports = __webpack_public_path__ + "static/media/invertedCommas.ef92a8e0.png";